import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.1.6_@babel+core@7.24.5_@playwright+test@1.50.0_babel-plugin-macros@3.1.0_react-dom@19_sa4oqclatvo6cn4r2xm2duygdy/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/contentful-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/divisor/index.tsx");
